import React from "react";
import { Link } from "react-router-dom";

const Nav = (props) => {
  const { openMod } = props;
  return (
    <header className="header">
      <div className="container-fluid container-xl d-flex align-items-center justify-content-between">
        <Link to="/" className="logo d-flex align-items-center">
          <img alt="Plugit" src="logo.png" />
        </Link>
        <nav id="navbar" className="navbar">
          <button className="butn butn-sec">
            <Link to={"/login"} className="gtl">
              <span className="gradText">Login</span>
            </Link>
          </button>
          <button className="butn butn-primary navSec" onClick={openMod}>
            Book a Demo
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Nav;
